import ProjectModel from "@/models/lab/ProjectModel";
import CustomerCollection from "@/collections/crm/CustomerCollection";
import LabServiceCollection from "@/collections/LabServiceCollection";

export default class ProjectCollection extends LabServiceCollection {
  model() {
    return ProjectModel;
  }

  prepareFilter(CollectionFilter) {
    CollectionFilter.sortAddDesc("pid");
    return CollectionFilter;
  }

  getCustomers() {
    const collection = new CustomerCollection();

    if (this.length) {
      this.each(project => {
        const customer = project.getCustomer();

        if (customer) {
          collection.add(customer);
        }
      });
    }
    
    return collection;
  }
}
